import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@core/pipes/translate.pipe';
import { SidebarComponent } from '@core/components/sidebar/sidebar.component';
import { AvatarComponent } from './ui/avatar';
import { AvatarGroupComponent } from './ui/avatar-group/avatar-group.component';
import { BadgeComponent } from './ui/badge';
import { TableCellComponent, TableComponent, TableHeaderCellComponent } from './ui/table';
import { PaginationCellComponent, PaginationComponent } from './ui/pagination';
import { AvatarUploadComponent } from './components/avatar-upload/avatar-upload.component';
import { DatePickerComponent } from './ui/date-picker';
import { DialogComponent } from './ui/dialog';
import { SelectListDialogComponent } from './components/select-list-dialog/select-list-dialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MessageDialogComponent } from './components/message-dialog/message-dialog.component';
import { ColorSelectComponent } from './components/color-select/color-select.component';
import { GroupedSelectDialogComponent } from './components/grouped-select-dialog/grouped-select-dialog.component';
import { UserInfoDialogComponent } from './components/user-info-dialog/user-info-dialog.component';
import { UserInfoUrlDialogComponent } from './components/user-info-url-dialog/user-info-url-dialog.component';
import { UserInfoUrlDeleteDialogComponent } from './components/user-info-url-delete-dialog/user-info-url-delete-dialog.component';
import { WeeklyScheduleComponent } from './components/weekly-schedule/weekly-schedule.component';
import { ProgressRingsComponent } from './components/progress-rings/progress-rings.component';
import { CalendarEventListDialogComponent } from './components/calendar-event-list-dialog/calendar-event-list-dialog.component';
import { CalendarEventDialogComponent } from './components/calendar-event-dialog/calendar-event-dialog.component';
import { CalendarRepeatSetDialogComponent } from './components/calendar-repeat-set-dialog/calendar-repeat-set-dialog.component';
import { CalendarEventConfirmDialogComponent } from './components/calendar-event-confirm-dialog/calendar-event-confirm-dialog.component';
import { CalendarEventScopeDialogComponent } from './components/calendar-event-scope-dialog/calendar-event-scope-dialog.component';
import { AdminTableSkeletonComponent } from './components/admin-table-skeleton/admin-table-skeleton.component';
import { AdminSplitSkeletonComponent } from './components/admin-split-skeleton/admin-split-skeleton.component';
import { TemplateDialogComponent } from './components/template-dialog/template-dialog.component';
import { EbookUploadDialogComponent } from './components/ebook-upload-dialog/ebook-upload-dialog.component';
import { IconHelperDirective } from './icon-helper/icon-helper.directive';
import { AppButtonDirective } from './ui/button';
import { ButtonGroupComponent } from './ui/button-group';
import { AppTooltipDirective } from './ui/tooltip';
import { InputComponent } from './ui/input';
import { IconToggleButtonComponent } from './ui/icon-toggle-button';
import { LabelComponent } from './ui/label';
import { LinkComponent } from './ui/link';
import { SwitchComponent } from './ui/switch';
import { CheckboxComponent } from './ui/checkbox';
import { RadioComponent } from './ui/radio';
import { TabsComponent } from './ui/tabs';
import { DropdownComponent } from './ui/dropdown';
import { MenuItemComponent } from './ui/menu-item';
import { MenuItemCollapsedComponent } from './ui/menu-item-collapsed/menu-item-collapsed.component';
import { PageLayoutComponent } from './ui/page-layout';
import { ToastComponent } from './ui/toast';
import { TagComponent } from './ui/tag/tag.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { A11yModule } from '@angular/cdk/a11y';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    TranslatePipe,
    SidebarComponent,
    AvatarComponent,
    AvatarGroupComponent,
    BadgeComponent,
    TableComponent,
    TableHeaderCellComponent,
    TableCellComponent,
    PaginationComponent,
    PaginationCellComponent,
    AvatarUploadComponent,
    DatePickerComponent,
    DialogComponent,
    SelectListDialogComponent,
    ConfirmDialogComponent,
    MessageDialogComponent,
    ColorSelectComponent,
    GroupedSelectDialogComponent,
    UserInfoDialogComponent,
    UserInfoUrlDialogComponent,
    UserInfoUrlDeleteDialogComponent,
    WeeklyScheduleComponent,
    ProgressRingsComponent,
    CalendarEventListDialogComponent,
    CalendarEventDialogComponent,
    CalendarRepeatSetDialogComponent,
    CalendarEventConfirmDialogComponent,
    CalendarEventScopeDialogComponent,
    InputComponent,
    IconToggleButtonComponent,
    LabelComponent,
    LinkComponent,
    SwitchComponent,
    CheckboxComponent,
    RadioComponent,
    TabsComponent,
    DropdownComponent,
    AdminTableSkeletonComponent,
    AdminSplitSkeletonComponent,
    TemplateDialogComponent,
    EbookUploadDialogComponent,
    IconHelperDirective,
    AppTooltipDirective,
    AppButtonDirective,
    ButtonGroupComponent,
    MenuItemComponent,
    MenuItemCollapsedComponent,
    PageLayoutComponent,
    TagComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    OverlayModule,
    PortalModule,
    A11yModule,
    FormsModule,
    ToastComponent
  ],
  exports: [
    TranslatePipe,
    SidebarComponent,
    AvatarComponent,
    AvatarGroupComponent,
    BadgeComponent,
    TableComponent,
    TableHeaderCellComponent,
    TableCellComponent,
    PaginationComponent,
    PaginationCellComponent,
    AvatarUploadComponent,
    DatePickerComponent,
    DialogComponent,
    SelectListDialogComponent,
    ConfirmDialogComponent,
    MessageDialogComponent,
    ColorSelectComponent,
    GroupedSelectDialogComponent,
    UserInfoDialogComponent,
    UserInfoUrlDialogComponent,
    UserInfoUrlDeleteDialogComponent,
    WeeklyScheduleComponent,
    ProgressRingsComponent,
    CalendarEventListDialogComponent,
    CalendarEventDialogComponent,
    CalendarRepeatSetDialogComponent,
    CalendarEventConfirmDialogComponent,
    CalendarEventScopeDialogComponent,
    InputComponent,
    IconToggleButtonComponent,
    LabelComponent,
    LinkComponent,
    SwitchComponent,
    CheckboxComponent,
    RadioComponent,
    TabsComponent,
    DropdownComponent,
    AdminTableSkeletonComponent,
    AdminSplitSkeletonComponent,
    TemplateDialogComponent,
    EbookUploadDialogComponent,
    IconHelperDirective,
    AppTooltipDirective,
    AppButtonDirective,
    ButtonGroupComponent,
    MenuItemComponent,
    MenuItemCollapsedComponent,
    PageLayoutComponent,
    ToastComponent,
    CommonModule,
    FormsModule,
    TagComponent
  ]
})
export class SharedModule { }
